export const getSelectedPacsConfig = (appConfig) => {
  const { WITH_PACS_SELECTOR, PACS_SELECTOR_CONFIG } = appConfig;

  if (!WITH_PACS_SELECTOR || !Array.isArray(PACS_SELECTOR_CONFIG)) return null;

  const selectedPacsIndex = sessionStorage.getItem('selectedPacsIndex');
  if (selectedPacsIndex === null) return null;

  return PACS_SELECTOR_CONFIG[selectedPacsIndex] || null;
};

export const checkAndLoadPacsSelectorConfig = (appConfig) => {
  const { WITH_PACS_SELECTOR, PACS_SELECTOR_CONFIG } = appConfig;

  if (!WITH_PACS_SELECTOR) return;
  if (!Array.isArray(PACS_SELECTOR_CONFIG)) return;
  if (PACS_SELECTOR_CONFIG.length < 1) return;

  // Validate PACS config object
  PACS_SELECTOR_CONFIG.forEach((pacsConfig, index) => {
    if (!(pacsConfig.name && pacsConfig.wadoRsUrl && pacsConfig.qidoRsUrl)) {
      console.error(`PACS selector config error: missing parameter on element number [${index}]`);
    }
  });

  if (!sessionStorage.getItem('selectedPacsIndex')) sessionStorage.setItem('selectedPacsIndex', '0');
};
